import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LicenceCreateDto, LicenceDto, LicenceTypeDto } from 'src/app/dtos/dtos';
import { LicenceService } from 'src/app/services/licence.service';
import { LicenceTypeService } from 'src/app/services/licenceType.service';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'je-licence',
  templateUrl: './licence.component.html',
  styleUrls: ['./licence.component.scss']
})
export class LicenceComponent implements OnInit {
  isEdit: boolean;
  licencePerma: string;
  accountPerma: string;
  licence: LicenceDto = new LicenceDto();
  licenceTypes: LicenceTypeDto[];

  constructor(
    private licenceService: LicenceService,
    private licenceTypeService: LicenceTypeService,
    private not: NotificationService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.isEdit = this.router.url.indexOf('new') == -1;
  }

  ngOnInit() {
    if (this.isEdit) {
      this.licencePerma = this.route.snapshot.paramMap.get('licencePerma');
      this.loadLicence();
    } else {
      const now = new Date();
      const thisYear = now.getFullYear().toString();
      this.licence.startDate = thisYear + '-01-01';
      this.licence.endDate = thisYear + '-12-31';
      this.licence.paid = false;
    }
    this.loadLicenceTypes();
    this.accountPerma = this.route.snapshot.paramMap.get('accountPerma');
  }

  private loadLicenceTypes() {
    this.licenceTypeService.getAll().subscribe(response => {
      this.licenceTypes = response;
    });
  }

  private loadLicence() {
    this.licenceService.get(this.licencePerma).subscribe(response => {
      this.licence = response;
    });
  }

  submit() {
    return this.isEdit ? this.update() : this.create();
  }

  create() {
    this.licenceService.create(this.getCreateDto(this.licence)).subscribe(() => {
      this.navigateBackToAccount();
    });
  }

  update() {
    this.licenceService.update(this.licencePerma, this.getCreateDto(this.licence)).subscribe(() => {
      this.navigateBackToAccount();
    });
  }

  private getCreateDto(licence: LicenceDto): LicenceCreateDto {
    const result = new LicenceCreateDto();
    result.startDate = licence.startDate;
    result.endDate = licence.endDate;
    result.paid = licence.paid;
    result.decision = licence.decision;
    result.decisionDate = licence.decisionDate;
    result.description = licence.description;
    result.typeId = licence.typeId ?? licence.type?.id;
    result.accountPermaId = this.accountPerma;
    return result;
  }

  delete() {
    this.not.confirm('Delete', 'Are you sure, you want to delete?')
      .afterClosed().subscribe(confirmed => {
        if (confirmed) {
          this.licenceService.delete(this.licencePerma).subscribe(() => {
            this.navigateBackToAccount();
          });
        }
      });
  }

  private navigateBackToAccount() {
    this.router.navigate([`/accounts/${this.accountPerma}`]);
  }

  public toggle(el: string, nullable?: boolean) {
    // eval('this.' + el + '=!this.' + el);
    switch (eval('this.' + el)) {
      case true:
        eval('this.' + el + '= false');
        break;
      case false:
        eval('this.' + el + '= nullable ? null : true');
        break;
      default:
        eval('this.' + el + '= true');
        break;
    }
  }
}